import { ResultExerciseValidation } from '@stores/interfaces';
import './style.css';
import { Spin, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { useTypedDispatch, useTypedSelector } from '@stores/index';

interface ISingleResultProps {
	exerciseName: string;
	enableToSendResult?: boolean;
	isPaused?: boolean;
	onNextTransition: () => void;
	resultExerciseValidation?: ResultExerciseValidation | null;
}

function SingleResult(props: ISingleResultProps) {
	const { uploadProgress } = useTypedSelector(state => state.rom.main);
	const uploadStatusPosture  = useTypedSelector(state => state.postures.postures.uploadProgress);
	const [uploadStatus, setUploadStatus] = useState<number>(uploadProgress || uploadStatusPosture || 0);

useEffect(() => {
		if (uploadProgress || uploadStatusPosture) {
			setUploadStatus(uploadProgress || uploadStatusPosture);
		}
	}, [uploadProgress, uploadStatusPosture]);

	const { resultsExercises, exercises } = useTypedSelector(
		state => state.rom.main,
	);
	const [showSpin, setSpin] = useState<boolean>(false);
	const dispatch = useTypedDispatch();

	useEffect(() => {
		if (
			uploadStatus === 100 &&
			resultsExercises.length + 1 != exercises?.length
		) {
			props.onNextTransition?.();
		} else if (
			uploadStatus === 100 &&
			resultsExercises.length + 1 != exercises?.length
		) {
			setSpin(true);
		}
	}, [uploadStatus, resultsExercises]);

	return (
		<div
			style={{
				position: 'absolute',
				zIndex: 3,
				width: '100%',
				height: '100%',
				background:
					'linear-gradient(130deg, rgba(166, 126, 255, 0.84) 0%, rgba(89, 101, 255, 0.84) 100%)',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				textAlign: 'center',
				color: '#FFF',
			}}>
			<div style={{ width: '50%' }}>
				<>
					<Typography.Title level={4} style={{ color: '#FFF' }}>
						COMPLETED
					</Typography.Title>
					{showSpin ? (
						<Spin
							className="spin-css spin-css-inbox"
							tip="Loading"
							size="large"
						/>
					) : (
						<>
							<Typography.Title
								level={3}
								style={{
									color: '#FFF',
									backgroundColor: '#03c852',
									padding: 10,
									borderRadius: '50px',
								}}>
								{`${props.exerciseName?.toUpperCase()} \u00a0\u00a0\u00a0`}
							</Typography.Title>
							<div className="upload-container">
								{uploadStatus > 0 ? (
									<>
										<div className="upload-label">
											Uploading, Please wait... {uploadStatus.toFixed(0)}%
										</div>
										<div className="upload-bar">
											<div
												className="upload-progress"
												style={{ width: `${uploadStatus}%` }}></div>
										</div>
									</>
								) : (
									<span className="upload-label">Processing ...</span>
								)}
							</div>
						</>
					)}
				</>
			</div>
		</div>
	);
}

export default SingleResult;
